<template>
  <v-card :loading="loading" v-bind="$attrs" v-on="$listeners">
    <v-card-title class="headline">Active {{ $i18n.translate("Promotions") }}</v-card-title>
    <v-card-subtitle>
      <span
        v-if="
          this.selectedFiscalYear && this.selectedFiscalYear.fiscalYearStart && this.selectedFiscalYear.fiscalYearEnd
        "
        ><b
          >({{ this.selectedFiscalYear.fiscalYearStart | formatDateClient("MM/DD/YYYY", selectedClient) }} -
          {{ this.selectedFiscalYear.fiscalYearEnd | formatDateClient("MM/DD/YYYY", selectedClient) }})</b
        ><br
      /></span>

      Active {{ $i18n.translate("Promotions") }} in the {{ $i18n.translate("Program") }}!<br
    /></v-card-subtitle>
    <v-card-text v-if="!loading">
      <v-data-table hide-default-footer :headers="headers" :items="items" :items-per-page="items.length">
        <template v-slot:item.promotionTypeKey="{ item }">
          <template v-if="$privilege.hasPrivilege('PROMOTION_READ')">
            <router-link :to="{ name: 'promotions', query: { promotionTypeKey: item.promotionTypeKey } }">
              {{ item.promotionTypeKey }}
            </router-link>
          </template>
          <template v-else>
            {{ item.promotionTypeKey }}
          </template>
        </template>
        <template v-slot:item.count="{ item }">
          {{ item.count | toNumber(0) }}
        </template>
        <template slot="body.append">
          <tr>
            <th colspan="2" class="text-right">Total</th>
            <th class="text-right">{{ sumField("count") | toNumber(0) }}</th>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions style="height: 55px">
      <v-spacer></v-spacer>
      <v-btn v-if="showActions" color="primary" :to="{ name: 'promotions', query: { active: 1 } }">Manage</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminPromotionsExpandedWidget",
  props: {
    showActions: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        {
          value: "promotionTypeKey",
          text: "Key",
          sortable: false
        },
        {
          value: "promotionTypeName",
          text: "Type",
          sortable: false
        },
        {
          value: "count",
          text: "Count",
          align: "right",
          sortable: false
        }
      ],
      items: [],
      loading: false
    };
  },
  watch: {
    selectedFiscalYear() {
      this.fetchData();
    },
    selectedProgram() {
      this.fetchData();
    }
  },
  computed: {
    ...mapGetters(["selectedProgram", "selectedClient", "selectedFiscalYear"])
  },
  methods: {
    sumField(key) {
      return this.items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    fetchData() {
      this.loading = true;

      this.$api
        .post("/api/promotions/search/group/byPromotionType?size=1", {
          isSubmissionsEffective: true,
          fiscalYear: this.selectedFiscalYear.fiscalYear
        })
        .then(({ data }) => {
          this.items = data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
